module.exports = __webpack_public_path__ + "img/slider1.8f788913.jpg";